/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconDelete = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--delete',
    className,
  )

  return (
    <IconBase className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 19"{...rest}><path className="path1" fill="#BDBDBD" fillRule="evenodd" d="M1.001 16.893c0 1.16.9 2.107 1.997 2.107h8.004c1.1 0 1.997-.947 1.997-2.107V4.22H1v12.672zM14 1.057h-3.502L9.503 0h-5L3.502 1.057H0v2.107h14V1.057z"/></IconBase>
  )
}

IconDelete.propTypes = {
  className: PropTypes.string,
}

export default IconDelete
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconDelete.js